import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    postLabTestPanelSuccess, postLabTestPanelFailure,
    getLabTestPanelSuccess, getLabTestPanelFailure,
    getLabTestPanelByIdSuccess, getLabTestPanelByIdFailure,
    putLabTestPanelSuccess, putLabTestPanelFailure,
    deleteLabTestPanelSuccess, deleteLabTestPanelFailure,
} from './slice';
import requestHandler from '../../../../utils/requestHandler';
import { logoutRequest } from '../../auth/authSlice';

function* postRequest(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "POST",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/panels`, requestDetail);
        yield put(postLabTestPanelSuccess(response));
    } catch (error) {
        yield put(postLabTestPanelFailure(error?.response?.message || error));
    }
}

function* getRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const { page, limit, searchQuery } = action.payload || { page: 1, limit: null, searchQuery: "" };
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/panels?page=${page}&limit=${limit}&searchQuery=${searchQuery}`, requestDetail);
        yield put(getLabTestPanelSuccess(response));
    } catch (error) {
        yield put(getLabTestPanelFailure(error?.response?.message || error));
    }
}

function* getByIdRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const requestDetail = {
            method: "GET",
            headers: {
                "Authorization": authToken,
                "Content-Type": "application/json",
                "X-Current-Branch": currentBranch.id
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/panels/${action.payload}`, requestDetail);
        yield put(getLabTestPanelByIdSuccess(response));
    } catch (error) {
        yield put(getLabTestPanelByIdFailure(error?.response?.message || error));
    }
}

function* putRequest(action) {
    try {
        const requestDetail = {
            method: "PUT",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(action.payload)
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/panels`, requestDetail);
        yield put(putLabTestPanelSuccess(response));
    } catch (error) {
        yield put(putLabTestPanelFailure(error?.response?.message || error));
    }
}

function* deleteRequest(action) {
    try {
        const requestDetail = {
            method: "DELETE",
            headers: {
                "Authorization": localStorage.getItem("item"),
                "Content-Type": "application/json"
            }
        };
        const response = yield call(requestHandler, `${process.env.REACT_APP_SERVER_API}api/laboratory/panels/${action.payload}`, requestDetail);
        yield put(deleteLabTestPanelSuccess(response));
    } catch (error) {
        yield put(deleteLabTestPanelFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('labTestPanel/postLabTestPanelRequest', postRequest);
    yield takeLatest('labTestPanel/getLabTestPanelRequest', getRequest);
    yield takeLatest('labTestPanel/getLabTestPanelByIdRequest', getByIdRequest);
    yield takeLatest('labTestPanel/putLabTestPanelRequest', putRequest);
    yield takeLatest('labTestPanel/deleteLabTestPanelRequest', deleteRequest);
}

export default saga;
